module.exports = __webpack_public_path__ + "platform/static/media/bellicon.386f5203.svg";